module.exports = __webpack_public_path__ + "img/portfolio-demo.97280963.gif";